import { render, staticRenderFns } from "./amChart.vue?vue&type=template&id=36509ebc"
import script from "./amChart.vue?vue&type=script&lang=js"
export * from "./amChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports